export const statsEN = {
  title: 'Stats & Evaluations'
}